export const API_BASE: string =
  window.location.origin.toString() === "http://localhost:3000"
    ? "http://localhost:8000"
    : `${window.location.origin.toString()}/backend`;
export const NEXT_PUBLIC_CLIENT_URL: string =
  window.location.origin.toString() === "http://localhost:3000"
    ? "http://localhost:8000"
    : `${window.location.origin.toString()}`;
export const DECOODA_API_BASE =
  window.location.origin.toString() === "http://localhost:3000"
    ? "http://localhost:8000/decooda"
    : `${window.location.origin.toString()}/backend/decooda`;
export const DIAGNOSTICS_API_BASE: string =
  window.location.origin.toString() === "http://localhost:3000"
    ? "http://localhost:8000/diagnostics"
    : `${window.location.origin.toString()}/backend/diagnostics`;
export const AI_METRICS_API_BASE: string =
  window.location.origin.toString() === "http://localhost:3000"
    ? "http://localhost:8000/ai-metrics"
    : `${window.location.origin.toString()}/backend/ai-metrics`;
export const PROJECT_IQ_API_BASE: string =
  window.location.origin.toString() === "http://localhost:3000"
    ? "http://localhost:8000/project-iq"
    : `${window.location.origin.toString()}/backend/project-iq`;

/**
 * Root of the server-rendered client view app.
 *
 * It is served by the same backend as the API, so it follows the same origin
 * rule: port 8000 when the SPA is running on the dev server, and the origin the
 * page is already on everywhere else.
 */
export const PROJECT_IQ_CLIENT_APP_BASE: string = `${PROJECT_IQ_API_BASE}/client/app`;

export const PROJECT_IQ_URL: string = import.meta.env.VITE_PROJECT_IQ_URL || "";

export const AIMS_URL: string = import.meta.env.VITE_CLIENT_URL || "";

const IS_PRODUCTION =
  window.location.origin === "https://projectiq.northhighland.ai";

export const AIMS_PROMPT_URL_PLACEHOLDER: string = IS_PRODUCTION
  ? "https://aims.northhighland.ai?promptId=..."
  : "https://aims-stage.northhighland.ai?promptId=...";
